export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            爆料投稿
          </h2>
          <p className="text-foreground-500 text-sm">你有猛料？我们为你发声</p>
        </div>

        <div className="bg-gradient-to-br from-primary-500/5 to-accent-500/5 border border-primary-200/40 rounded-xl p-8 md:p-10 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h3 className="text-xl font-bold text-foreground-950 mb-3 font-heading">
            有料要爆？欢迎联系我们
          </h3>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto">
            我们承诺严格保护爆料人隐私，所有投稿均采用匿名处理机制。
            您提供的每一条线索，我们都会认真核实并追踪报道。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center gap-2 px-5 py-3 bg-background-50 border border-background-200/70 rounded-lg">
              <i className="ri-mail-line text-primary-500"></i>
              <span className="text-foreground-700 text-sm">tougao@chiguaheiliaobaoliao.com</span>
            </div>
            <a
              href="#faq"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              查看投稿须知
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}